<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6" class="py-4">
        <v-breadcrumbs :items="urls" class="pa-0"></v-breadcrumbs>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6" class="px-4 py-10 white">
        <div class="d-flex mx-3">
          <v-img :src="logo.photo" max-height="32" max-width="131" contain />
        </div>
        <div class="my-4">
          <SignIn
            v-if="this.nowComponents === 'SignIn'"
            v-on:switch="Switch"
            v-on:token="GetToken"
          />
          <SignUp
            v-if="this.nowComponents === 'SignUp'"
            v-on:switch="Switch"
            v-on:token="GetToken"
          />
          <SetAccount
            v-if="this.nowComponents === 'SetAccount'"
            v-on:switch="Switch"
            v-on:token="GetToken"
          />
          <ResetPwd
            v-if="this.nowComponents === 'ResetPwd'"
            v-on:switch="Switch"
            v-on:token="GetToken"
          />
          <VerifyEmail
            v-if="this.nowComponents === 'VerifyEmail'"
            v-on:switch="Switch"
            v-on:token="GetToken"
          />
          <UpdatePwd
            v-if="this.nowComponents === 'UpdatePwd'"
            v-on:switch="Switch"
            v-on:token="GetToken"
          />
          <UpdatePwdSuccess
            v-if="this.nowComponents === 'UpdatePwdSuccess'"
            v-on:switch="Switch"
            v-on:token="GetToken"
          />
          <VerifyExpired
            v-if="this.nowComponents === 'VerifyEmailExpired'"
            v-on:switch="Switch"
            v-on:token="GetToken"
          />
          <VerifyEmailSuccess
            v-if="this.nowComponents === 'VerifyEmailSuccess'"
            v-on:token="GetToken"
          />
          <SignUpSuccess
            v-if="this.nowComponents === 'SignUpSuccess'"
            v-on:token="GetToken"
          />
        </div>
        <!-- <div>
          <v-btn
            class="pa-0 text-decoration-underline"
            text
            small
            plain
            @click="GoPage('Disclaimer')"
          >
            {{ disclaimer }}
          </v-btn>
          <span class="text-caption text--secondary">{{ " & " }}</span>
          <v-btn
            class="pa-0 text-decoration-underline"
            text
            small
            plain
            @click="GoPage('PrivacyPolicy')"
          >
            {{ privacyPolicy }}
          </v-btn>
        </div> -->
        <div class="mt-2 text-caption text--disabled">{{ copytight }}</div>
      </v-col>
    </v-row>

    <!-- #region 社群ifrom -->
    <iframe
      id="sms"
      ref="sms"
      :src="serivces.sms"
      style="display: none"
    ></iframe>
    <!-- #endregion -->

    <!-- #region 工作站ifrom -->
    <iframe id="wt" ref="wt" :src="serivces.wt" style="display: none"></iframe>
    <!-- #endregion -->
  </v-container>
</template>

<script>
import SignIn from "../components/SignIn/SignIn.vue";
import SignUp from "../components/SignIn/SignUp.vue";
import SetAccount from "../components/SignIn/SetAccount.vue";
import SignUpSuccess from "../components/SignIn/SignUpSuccess.vue";
import ResetPwd from "../components/SignIn/ResetPwd.vue";
import VerifyEmail from "../components/SignIn/VerifyEmail.vue";
import UpdatePwd from "../components/SignIn/UpdatePwd.vue";
import UpdatePwdSuccess from "../components/SignIn/UpdatePwdSuccess.vue";
import VerifyExpired from "../components/SignIn/VerifyExpired.vue";
import VerifyEmailSuccess from "../components/SignIn/VerifyEmailSuccess.vue";

export default {
  components: {
    SignIn,
    SignUp,
    SetAccount,
    ResetPwd,
    VerifyEmail,
    UpdatePwd,
    UpdatePwdSuccess,
    VerifyExpired,
    VerifyEmailSuccess,
    SignUpSuccess,
  },
  data: () => ({
    nowComponents: "",
    logo: {
      photo: require("@/assets/ltLogo.svg"),
      name: "小芋頭",
    },
    urls: [
      {
        text: "",
        disabled: false,
        href: "",
        target: "_blank",
      },
      {
        text: "登入",
        disabled: true,
        href: "",
      },
    ],
    fromSiteConfigs: {
      name: "",
      pageName: "",
      url: "",
    },
    userEmail: "",
    copytight: "COPYRIGHT © 小芋頭工作室 All rights reserved.",
    disclaimer: "免責聲明",
    privacyPolicy: "隱私權政策",
    serivces: {
      sms: process.env.VUE_APP_MAIN_SMS_BASE_URL,
      wt: process.env.VUE_APP_MAIN_WT_BASE_URL,
    },
  }),
  mounted() {
    // 從store抓哪個網站過來的
    this.fromSiteConfigs = this.$store.state.fromSite;
    console.log(this.fromSiteConfigs);
    // 抓最後元件位置
    let lastLocation = localStorage.getItem("lastLocation");
    this.nowComponents = lastLocation === null ? lastLocation : "SignIn";

    if (this.$route.query.status) {
      // 抓queryString (status=) 並替換對應元件畫面與切換麵包屑
      this.nowComponents = this.$route.query.status;
    }
    this.MatchQuerySwitchComponents(this.nowComponents);
    this.BreadcrumbsSwitch(this.nowComponents);
    this.Switch(this.ReplacefirstStrToUpper(this.nowComponents));
  },
  watch: {
    // 監聽Vuex的state.fromSiteConfigs參數來渲染畫面
    fromSiteConfigs() {
      this.urls[0].text = this.fromSiteConfigs.name;
      this.urls[0].href = this.fromSiteConfigs.url;
    },
    immediate: true,
    deep: true,
  },
  methods: {
    // 登入後 PostToken到各服務
    PostToken(token) {
      console.log(token);
      this.$refs.sms.contentWindow.postMessage(token, this.serivces.sms);

      console.log(this.$refs.wt);
      this.$refs.wt.contentWindow.postMessage(token, this.serivces.wt);
    },
    // 從components取得Token
    GetToken(data) {
      this.PostToken(data);
    },
    GoPage(router) {
      this.$router.push({ name: router });
    },
    // 將字首轉成大寫
    ReplacefirstStrToUpper(str) {
      return str.replace(str.substr(0, 1), str.substr(0, 1).toUpperCase());
    },
    //  $emit 換元件名稱來切換顯示
    Switch(data) {
      this.nowComponents = data;
      this.BreadcrumbsSwitch(data);
      // 存最後元件位置
      localStorage.setItem("lastLocation", data);
    },
    // 換麵包屑名稱
    BreadcrumbsSwitch(ComponentsName) {
      let index = 1;
      switch (ComponentsName) {
        case "SignIn":
          this.urls[index].text = "登入";
          break;
        case "SignUp":
          this.urls[index].text = "註冊";
          break;
        case "setAccount" || "SetAccount":
        case "SignUpSuccess":
          this.urls[index].text = "設定密碼";
          break;
        case "ResetPwd":
        case "UpdatePwd":
        case "UpdatePwdSuccess":
          this.urls[index].text = "重設密碼";
          break;
        case "VerifyEmail":
        case "VerifyExpired":
        case "VerifyEmailSuccess":
          this.urls[index].text = "驗證";
          break;
      }
    },

    // 從queryString對應渲染畫面
    MatchQuerySwitchComponents(query) {
      switch (query) {
        case "setAccount":
          this.nowComponents = "SetAccount";
          break;
        case "updatePwd":
          this.nowComponents = "UpdatePwd";
          break;
        case "verifyExpired":
          this.nowComponents = "VerifyExpired";
          break;
        case "verifyEmailSuccess":
          this.nowComponents = "VerifyEmailSuccess";
          break;
        case "signUp":
          this.nowComponents = "SignUp";
          break;
        case "signIn":
          this.nowComponents = "SignIn";
          break;
      }
    },
  },
};
</script>
